import Vue from 'vue';
import VueResource from 'vue-resource';
import { NAMES } from '../config';
import { getCookie, isLogin, signOut } from '../utils/authService';

Vue.use(VueResource);

// HTTP
// Vue.http.options.crossOrigin = true;
// Vue.http.options.credentials = true;

Vue.http.interceptors.push((request, next) => {
  request.headers = request.headers || {};
  if (isLogin()) {
    request.headers.set('security-token', getCookie('token').replace(/(^")|("$)/g, ''))
  }

  request.headers.set("content-type", "application/json");
  next((response) => {
    if (response.status === 401) {
      signOut();
      window.location = window.location.href.split('#')[0] + '#/login'

    }
  })
});


export const UserResource = Vue.resource(NAMES.fullUrl + 'user{/PATH*}{/ID}{?Q*}');
export const AddressResource = Vue.resource(NAMES.fullUrl + 'address{/PATH*}{/ID}{?Q*}');
export const PaymentResource = Vue.resource(NAMES.fullUrl + 'formpayment{/PATH*}{/ID}{?Q*}')
export const SettingsResource = Vue.resource(NAMES.fullUrl + 'param{/PATH*}{/ID}{?Q*}');
export const PasswordResource = Vue.resource(NAMES.fullUrl + 'password{/PATH*}{/ID}{?Q*}');
export const DashboardResource = Vue.resource(NAMES.fullUrl + 'dashboard{/PATH*}{/ID}{?Q*}');
export const SupportResource = Vue.resource(NAMES.fullUrl + 'support{/PATH*}{/ID}{?Q*}');
export const NotificationResource = Vue.resource(NAMES.fullUrl + 'notification{/PATH*}{/ID}{?Q*}');
export const MaterialResource = Vue.resource(NAMES.fullUrl + 'material{/PATH*}{/ID}{?Q*}');
export const CategoryResource = Vue.resource(NAMES.fullUrl + 'category{/PATH*}{/ID}{?Q*}');
export const TypeFuelResource = Vue.resource(NAMES.fullUrl + 'typefuel{/PATH*}{/ID}{?Q*}');
export const ColorsResource = Vue.resource(NAMES.fullUrl + 'colors{/PATH*}{/ID}{?Q*}');
export const ManufactureResource = Vue.resource(NAMES.fullUrl + 'manufacturer{/PATH*}{/ID}{?Q*}');
export const MeasureResource = Vue.resource(NAMES.fullUrl + 'measure{/PATH*}{/ID}{?Q*}');
export const CarResource = Vue.resource(NAMES.fullUrl + 'car{/PATH*}{/ID}{?Q*}');
export const AuctionResource = Vue.resource(NAMES.fullUrl + 'auction{/PATH*}{/ID}{?Q*}');
export const PromotionResource = Vue.resource(NAMES.fullUrl + 'promotion{/PATH*}{/ID}{?Q*}');
export const WhatsappResource = Vue.resource(NAMES.fullUrl + "whatsapp{/PATH*}{/ID}{?Q*}");
export const BatteryResource = Vue.resource(NAMES.fullUrl + "whatsapp/battery{/PATH*}{/ID}{?Q*}");
export const GraphResource = Vue.resource(NAMES.fullUrl + 'graph{/PATH*}{/ID}{?Q*}');
export const GraphUserResource = Vue.resource(NAMES.fullUrl + 'graph/user{/PATH*}{/ID}{?Q*}');
export const GraphOperatorResource = Vue.resource(NAMES.fullUrl + 'graph/operator{/PATH*}{/ID}{?Q*}');
export const GraphTransactionResource = Vue.resource(NAMES.fullUrl + 'graph/transaction{/PATH*}{/ID}{?Q*}');
export const GraphRechargeResource = Vue.resource(NAMES.fullUrl + 'graph/recharge{/PATH*}{/ID}{?Q*}');
export const GraphWalletResource = Vue.resource(NAMES.fullUrl + 'graph/wallet{/PATH*}{/ID}{?Q*}');
export const VipResource = Vue.resource(NAMES.fullUrl + 'vip{/PATH*}{/ID}{?Q*}');



// WEBPACK FOOTER //
// ./src/api/resource.js